import { FragmentType, graphql, useFragment } from "@/gql"
import { MyJobActionButtonsFragment, MyJobActionButtonsFragmentDoc } from "@/gql/graphql"
import { FC } from "react"
import { Action, determineJobPostingAction } from "../../utilts"
import { CloseJob } from "../jobCardActions/CloseJob"
import { InviteCreatives } from "../jobCardActions/InviteCreatives"
import { MessageApplicants } from "../jobCardActions/MessageApplicants"
import { ReviewApplicants } from "../jobCardActions/ReviewApplicants"
import { ampli } from "@/ampli"
import type { NovaSession } from "@/types"
import { decodeGraphqlNodeId } from "@/tracking"

graphql(`
  fragment MyJobActionButtons on JobPosting {
    id
    __typename
    completionStatus {
      id
      currentStep
    }
    ...MyJobsJobPostStatusDeterminator
    ...InviteCreativesAction
    ...ReviewApplicantsAction
    ...MessageApplicantsAction
    ...CloseJobAction
  }
`)

export interface Props {
  jobPosting: FragmentType<typeof MyJobActionButtonsFragmentDoc> | null | undefined
  serverSession: NovaSession
}

export const getAction = (
  jobAction: Action,
  jobPosting: MyJobActionButtonsFragment | null | undefined,
  serverSession: NovaSession
) => {
  const track = (
    shortcutType: "invites" | "unreviewed" | "shortlisted" | "messages" | "close" | "suggestedCreatives"
  ) => {
    ampli.activeJobCardShortcut({
      job_id: decodeGraphqlNodeId(jobPosting?.id).numericalId || "",
      shortcut_type: shortcutType,
      status: jobPosting?.completionStatus?.currentStep || "",
    })

    if (shortcutType === "close") {
      ampli.jobPostClose({
        job_id: decodeGraphqlNodeId(jobPosting?.id).numericalId || "",
        entry_point: "job_card_shortcut",
        status: jobPosting?.completionStatus?.currentStep || "",
        account_type: serverSession?.account || "",
      })
    }
  }
  switch (jobAction) {
    case Action.SEND_INVITE:
      return <InviteCreatives jobPostingFragment={jobPosting} track={track} />
    case Action.REVIEW_APPLICATIONS:
      return <ReviewApplicants jobPostingFragment={jobPosting} track={track} />
    case Action.MESSAGE_APPLICANTS:
      return <MessageApplicants jobPostingFragment={jobPosting} track={track} />
    case Action.CLOSE_JOB:
      return <CloseJob jobPostingFragment={jobPosting} track={track} />
    default:
      return <InviteCreatives jobPostingFragment={jobPosting} track={track} />
  }
}

export const MyJobActions: FC<Props> = props => {
  const jobPosting = useFragment(MyJobActionButtonsFragmentDoc, props.jobPosting)
  const jobAction = determineJobPostingAction(jobPosting)
  const jobActionElement = getAction(jobAction, jobPosting, props.serverSession)

  return (
    <div
      className="hidden w-[322px] shrink-0 flex-col divide-y divide-bg-3 overflow-hidden rounded-[10px] border border-bg-3 bg-bg-1 md:flex"
      style={{
        boxShadow: "0px 4px 24px 0px rgba(0, 0, 0, 0.10)",
      }}>
      {jobActionElement}
    </div>
  )
}
